import { useContext } from "react";
import NonIdealNew from "../../common/NonIdealNew";
import { LanguageContext } from "../../../context/LanguageContext";
import { analytics, triggerLogEvent } from "../../../config/firebase";
import { useLocation, useNavigate } from "react-router-dom";
import { Grid } from "@mui/material";
import { InnerWrapper, MainContainer, TitleAndActionBox } from "../../common";
import { UBButton } from "../../../Libraries";
import withObservables from "@nozbe/with-observables";
import { observeSaleInvoicesByBusinessCount } from "../../../database/helpers/invoice";
import SalePurchaseList from "../NewInvoiceBook/InvoiceBookPages/SalePurchaseList";
import { useAuthContext } from "../../../context/AuthContext";
import "../QuickSale/styles.css";
import { PlayIcon } from "../../../assets/icons/icon";
import { useFiltersHandler } from "../../../hooks/useFilterHandler";

const SaleInvoices = ({ invoiceListCount }) => {
  const [I18n] = useContext(LanguageContext);
  const navigate = useNavigate();
  const location = useLocation();
  const { business, user } = useAuthContext();

  const { filters } = useFiltersHandler(undefined, I18n);

  const handleAddSaleInvoice = () => {
    triggerLogEvent(analytics, "inv_create");
    navigate("/InvoiceBook/Create", {
      state: {
        pathname: location.pathname,
        data: { invoiceCount: invoiceListCount },
      },
    });
  };

  const isNonIdeal = invoiceListCount <= 0;
  return (
    <MainContainer fluid className="quickSalePage">
      <Grid container>
        <Grid item md={12}>
          <TitleAndActionBox
            data={{
              title: I18n.sale_invoice,
            }}
          >
            <UBButton
              onClick={handleAddSaleInvoice}
              id={"create_invoice"}
              className="ubPrimaryButton fontSize12 fontWeight400 textUppercase marginLeft12"
              title={I18n.create_invoice}
            />
          </TitleAndActionBox>
          <InnerWrapper className="innerWrapper newInnerWrapper">
            {isNonIdeal ? (
              <NonIdealNew
                title={I18n.create_sale_invoice}
                subtitle={I18n.start_creating_your_first_sale_invoice}
                button1Title={"create_invoice"}
                // button2Title="watch_video"
                onButton1Click={handleAddSaleInvoice}
                loading={false}
                disabledOne={false}
                disabledTwo={false}
                buttonOneId={"create_invoice"}
                buttonTwoId={"watch_video"}
                prefixIconButtonTwo={
                  <PlayIcon width="18px" height="18px" fill="var(--blue500)" />
                }
                video_footer={{
                  title: I18n.create_invoice,
                  onClick: handleAddSaleInvoice,
                }}
                video_url={
                  "https://www.youtube.com/embed/KpMpGauNeDc?si=_xvfwB-A25WKNQO1"
                }
                videoTitle={I18n.create_sale_invoice}
                videoSubtitle={I18n.start_creating_your_first_sale_invoice}
              />
            ) : (
              <SalePurchaseList
                invoiceListCount={invoiceListCount}
                business={business}
                user={user}
                type={"in"}
                filters={filters}
              />
            )}
          </InnerWrapper>
        </Grid>
      </Grid>
    </MainContainer>
  );
};

const enhance = withObservables([], () => ({
  invoiceListCount: observeSaleInvoicesByBusinessCount(
    localStorage.getItem("business_id"),
  ),
}));

export default enhance(SaleInvoices);
